import { currentTenant } from "../configs/tenantConfig";
import ooru from "./ooru";
import stp from "./stp";

const registry = {
  ooru,
  stp,
};

export const tenant = registry[currentTenant] ?? ooru;
export const getTenant = () => tenant;
